// 修改点：社区Swap的标志，用于区分不同的Swap，非常重要，非dev分支上传
export const SubSwapName = 'bit';
export const SubBannerKey = '10';